import React from 'react';
import { Container, Typography } from '@mui/material';
import { PasswordUpdate } from '../components/PasswordUpdate';

export const PasswordUpdatePage: React.FC = () => (
  <Container maxWidth="sm">
    <Typography variant="h4" align="center" sx={{ mt: 8 }}>
      Set New Password
    </Typography>
    <PasswordUpdate />
  </Container>
);
